


















































































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import {
  IImportProviderData,
  IImportProviderMethods,
  IImportStep
} from "@/models/imports";
import Context from "@/mixins/context";
import { ImportStatuses } from "@/data/status";
import {
  ImportStatusCodes as ISC,
  ImportStatusMap
} from "@/data/enums/imports";

@Component({
  components: {
    "import-step-body": () =>
      import("@/components/app/admin/imports/importStepBody.vue")
  }
})
export default class ImportStepVessel extends Mixins(Context) {
  // Inject

  @Inject({ from: "importProvider" })
  public readonly $importProvider!: () => IImportProviderData;

  @Inject({ from: "importMethods" })
  public readonly $importMethods!: IImportProviderMethods;

  // Props

  @Prop({ required: true })
  public readonly step!: IImportStep;

  @Prop({ required: true })
  public readonly stepNumber!: number;

  // Computed

  public get $importData() {
    return this.$importProvider();
  }

  public get isExpandable() {
    const statuses = [
      ISC.PENDING,
      ISC.CANCELLED,
      ISC.ERROR,
      ISC.COMPLETE,
      ISC.STEP_SKIPPED
    ];
    if (statuses.includes(this.$importData.import.status.code)) return false;
    return !statuses.includes(this.step.status.code);
  }

  public get isSkipped() {
    return [ISC.STEP_SKIPPED].includes(this.step.status.code);
  }

  public get isPending() {
    return [ISC.PENDING].includes(this.step.status.code);
  }

  public get hasError() {
    return [ISC.ERROR].includes(this.step.status.code);
  }

  public get stepSummary() {
    const map = ImportStatusMap()[this.step.status.code];
    return this.$_.get(map, "summary", () => "")(this.step);
  }

  public get showProgress() {
    return [ISC.EXPORTING, ISC.IN_PROGRESS].includes(this.step.status.code);
  }

  public get stepType() {
    return this.$_.get(ImportStatuses[this.step.status.code], "type", "");
  }
}
